export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Modo de compra',
	plural_model_name_spanish: 'Modo de compra',
	create_model_name_spanish: 'Nuevo Modo de compra',
	text_delete: 'el',
}